import DtoStandardCodification from '../../referential/dto/DtoStandardCodification'

export default class DtoIndustrialSeveso extends DtoStandardCodification {
	constructor(obj) {
		super(obj)
	}
}



// WEBPACK FOOTER //
// ./src/station/dto/DtoIndustrialSeveso.js